// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3mpZ2","inputWrap":"styles_inputWrap__zzlOK","input":"styles_input__3b_zo"};